import axios from 'axios';

import { getEnvConfig } from 'config/environment';
import { UserManagementRepositoryImpl } from 'repository/grapqhlRepository/userManagementRepository';
import { type CloudResult, type RepositoryCacheType } from 'repository/repository';
import type UserManagementService from 'services/userManagement/userManagementService';
import { type AuthenticatedUserInterface, type ClubSparkAuthenticationInterface } from 'typedefs/authTypes';
import { type UserAdminOrSuperAdmin } from 'typedefs/store/tmxTypes';

class UserManagementServiceImpl implements UserManagementService {
  userManagementRepository = new UserManagementRepositoryImpl();

  getUserPermissions(
    tournamentId: string,
    cache?: RepositoryCacheType | undefined,
  ): Promise<CloudResult<UserAdminOrSuperAdmin>> {
    return this.userManagementRepository.getUserPermissions(tournamentId, cache);
  }

  saveToStorage(user?: AuthenticatedUserInterface, token?: string | undefined): ClubSparkAuthenticationInterface {
    const metadata = {
      token: token,
    };
    const clubSparkAuth = { user: user, metadata };

    if (token && user) {
      localStorage.setItem('authenticatedUser', JSON.stringify(clubSparkAuth));
    } else {
      localStorage.removeItem('authenticatedUser');
    }

    return clubSparkAuth;
  }
  getFromStorage(): ClubSparkAuthenticationInterface | undefined {
    const currentUser = localStorage.getItem('authenticatedUser');
    const isDefined = currentUser !== 'undefined';
    return isDefined ? (JSON.parse(currentUser) as ClubSparkAuthenticationInterface) : undefined;
  }
  async getCurrentUser() {
    const getToken = async () => {
      const tokenAuthUrl = `${getEnvConfig().REACT_APP_CLUBSPARK_DOMAIN_URL}/account/tokens?clientid=clubspark-app`;
      return await axios.get(tokenAuthUrl, {
        withCredentials: true,
      });
    };
    const clubsparkAuthAPIURL = `${getEnvConfig().REACT_APP_CLUBSPARK_DOMAIN_URL}/v2`;
    const clubsparkAuthAPIGetCurrentUserPath = getEnvConfig().REACT_APP_CLUBSPARK_AUTH_GET_CURRENT_USER_PATH;
    const http = axios.create({
      baseURL: clubsparkAuthAPIURL,
      withCredentials: true,
    });
    const response = await http.get(clubsparkAuthAPIGetCurrentUserPath);
    if (response.data) {
      const tokenResponse = await getToken();
      const token = tokenResponse.headers['x-api-token'];
      return this.saveToStorage(response.data, token);
    }

    this.saveToStorage();
    return response;
  }

  signIn(redirectToURLAfterSignIn: string) {
    const clubSparkAuthSignInURL = `${getEnvConfig().REACT_APP_CLUBSPARK_DOMAIN_URL}/Account/SignIn`;
    window.location.assign(`${clubSparkAuthSignInURL}?returnUrl=${redirectToURLAfterSignIn}`);
  }
  signOut() {
    const clubSparkAuthSignOutURL = `${getEnvConfig().REACT_APP_CLUBSPARK_DOMAIN_URL}/Account/SignOut`;
    window.location.assign(`${clubSparkAuthSignOutURL}?returnUrl=${window.location.origin.toString()}/login`);
  }
}

export default new UserManagementServiceImpl();
